module.exports = __webpack_public_path__ + "static/media/watch-fitness.0725bd57.svg";